import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import CheckboxItem from './CheckboxItem';

const CheckboxField = ({
  control,
  name,
  label,
  disabled,
  showOnNewLine,
  onChange, // <-- new
}) => (
  <Controller
    control={control}
    name={name}
    defaultValue={false}
    render={({ field }) => (
      <CheckboxItem
        name={name}
        label={label}
        checked={!!field.value}
        disabled={disabled}
        showOnNewLine={showOnNewLine}
        onChange={(val) => {
          field.onChange(val); 
          if (onChange) onChange(val);
        }}
      />
    )}
  />
);

CheckboxField.propTypes = {
  control: PropTypes.shape({}).isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  showOnNewLine: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CheckboxField;
